<template>
    <div class="xing-b">
        <i v-for="(xx, xInd) in sels" :key="xInd" :class="['iconfont icon-xingxing xing', getXing(xInd)]" :style="getColor(xInd)" @click.stop="saveXing(xx.value || xx)" />
    </div>
</template>

<script>
export default {
    name: 'radio-xing',
    props: {
        sels: {
            type: Array,
            default: () => {
                return []
            }
        },
        value: {
            type: [Number, String],
            default: ''
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            localValue: this.value
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.localValue = newVal
            },
            immediate: true
        }
    },
    methods: {
        getColor (ind) {
            const c = this.getXing(ind)
            if (c && this.sels.length > 0 && this.sels[0].color) {
                return { color: this.sels[0].color }
            }
        },
        saveXing(val) {
            if (!this.edit) return
            this.localValue = this.localValue === val ? '' : val
            // 发出事件通知父组件
            this.$emit('upXing', this.localValue)
        },
        getXing(ind) {
            if (!this.localValue && this.localValue !== 0) return ''
            const gI = (this.sels || []).findIndex(it => it.value == this.localValue)
            if (gI !== -1) {
                return gI >= ind ? 'xing-active' : ''
            }
            return ''
        }
    }
}
</script>

<style scoped lang="scss">
.xing-b {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.xing {
    margin-right: 23px;
    color: #D8D8D8;
    font-size: 16px;
    cursor: pointer;
    &:last-child {
        margin-right: 0;
    }
}
.xing-active {
    color: #FFD12F;
}
</style>